export const ENDPOINTS = {
    FETCH_REPORT_DATA: "/webapi/objetivos/data-v2",
    // FETCH_OBJECTIVE_CONFIGS: "/webapi/objetivos/search",
    FETCH_ASSIGNED_OBJECTIVES: "/webapi/objetivos/assigned",
    FETCH_ALL_OBJECTIVES: "/webapi/objetivos/search",
    SYNC_OBJECTIVE_ASSIGNMENTS: "/webapi/objetivos/sync",
    // FETCH_OBJECTIVE_DETAILS: "/webapi/objetivos/details",
    FETCH_OBJECTIVE_FIELDS: "/webapi/data/labels",
};
export const OBJECTIVES_TABLES = {
    COLUMNAS_SELECCIONADAS: "columnas_seleccionadas",
    COLUMNAS_SELECCIONADAS_CENTER_VOLUMEN_CASTILLA: "columnas_seleccionadas_center_volumen_castilla",
    COLUMNAS_SELECCIONADAS_GDA_CENTERS: "columnas_seleccionadas_gda_centers",
    COLUMNAS_SELECCIONADAS_CENTER_RUTAS_CASTILLA: "columnas_seleccionadas_center_rutas_castilla",
};
export const OBJECTIVES_TABLES_LIST = Object.values(OBJECTIVES_TABLES);
